<script setup lang="ts">
  import { Typo } from '@travelata-libs/ui-kit';
  import { TouristsRoomsPanel } from '@/features/searchForm';
  import MobileChildAgeScreen from './screens/MobileChildAgeScreen.vue';
  import { useMobileSearchFlowContext } from '../../model/useMobileSearchFlow';

  const flow = useMobileSearchFlowContext();
</script>

<template>
  <div class="tourists-rooms-template">
    <TouristsRoomsPanel
      :model-value="flow.tourists.value"
      :is-visible-add-button="flow.isVisibleRoomButton.value"
      @update:modelValue="flow.updateTourists"
      @open-age-picker="flow.openAgePicker"
    />
    <Typo
      v-if="flow.isVisibleRoomButton.value"
      class="tourists-rooms-template__typo"
      variant="body-s-400"
    >
      Можно бронировать
      <span class="tourists-rooms-template__yellow">только одинаковые номера</span>
    </Typo>

    <MobileChildAgeScreen v-if="flow.isAgePickerOpen.value" />
  </div>
</template>

<style scoped lang="scss">
  .tourists-rooms-template {
    box-sizing: border-box;
    width: 100%;

    &__typo {
      color: var(--color-text-primary);
      margin-top: var(--spacing-xs);
    }

    &__yellow {
      background-color: var(--color-yellow-05);
    }
  }
</style>
